import { IMeta } from '@bees-web/core/types'
import {
  CONTENT_LOADED,
  MAIN_CATEGORY_TILE_CLICKED,
  MAIN_CATEGORY_TILE_VIEWED,
} from '../../constants/categories'
import { ITrackableHomepageCategoriesAction } from '../../interfaces/categories'

export const trackCategoryTileClickedSegmentsViewed = ({
  position = null,
  screen_name = null,
  store_id = null,
  tile_name = null,
  vendor_list = null,
  module_name = null,
  referrer = null,
  value_stream = 'HOMEPAGE',
}: IMeta): ITrackableHomepageCategoriesAction => ({
  type: MAIN_CATEGORY_TILE_CLICKED,
  payload: {
    position,
    referrer,
    screen_name,
    store_id,
    module_name,
    tile_name,
    value_stream,
    vendor_list,
  },
})

export const trackMainCategoryTileViewed = ({
  category_tile_list = [],
  referrer = null,
  screen_name = null,
  store_id = null,
  module_name = null,
  value_stream = 'HOMEPAGE',
}: IMeta): ITrackableHomepageCategoriesAction => ({
  type: MAIN_CATEGORY_TILE_VIEWED,
  payload: {
    category_tile_list,
    referrer,
    screen_name,
    module_name,
    store_id,
    value_stream,
  },
})

export const trackContentLoaded = ({
  screen_name = null,
  value_stream = null,
  section_name = null,
  store_id = null,
  referrer = null,
}: IMeta): ITrackableHomepageCategoriesAction => ({
  type: CONTENT_LOADED,
  payload: {
    screen_name,
    value_stream,
    section_name,
    store_id,
    referrer,
  },
})
